import {
  isValidDurationValue,
  isValidTimestampValue,
  type ValidationPreviewData,
} from './validationDataChecks';
import { ValidationFilePreviewSection } from './ValidationFilePreviewSection';
import type { ReactElement } from 'react';

type ProjectCsvValidationPreviewResultsSectionProps = {
  fileName: string | null;
  previewHeaders: string[];
  previewBodyRows: string[][];
  previewData: ValidationPreviewData;
  normalizeHeader: (value: string) => string;
  normalizeStatus: (value: string) => string;
  resolveMatchedHeaderLabel: (header: string) => string | null;
  resolveMatchedStatusLabel: (value: string, columnIndex: number) => string | null;
};

export const ProjectCsvValidationPreviewResultsSection = ({
  fileName,
  previewHeaders,
  previewBodyRows,
  previewData,
  normalizeHeader,
  normalizeStatus,
  resolveMatchedHeaderLabel,
  resolveMatchedStatusLabel,
}: ProjectCsvValidationPreviewResultsSectionProps): ReactElement => {
  const previewTableRows = previewBodyRows.slice(0, 10);

  return (
    <>
      <ValidationFilePreviewSection
        fileName={fileName}
        headers={previewHeaders}
        rows={previewTableRows}
        isMatchedHeader={(header) => previewData.matchedHeaders.has(normalizeHeader(header))}
        resolveHeaderMatchLabel={resolveMatchedHeaderLabel}
        isStatusColumn={(columnIndex) =>
          previewData.previewStatusColumnIndexes.includes(columnIndex)
        }
        isDurationColumn={(columnIndex) =>
          previewData.previewDurationColumnIndexes.includes(columnIndex)
        }
        isTimestampColumn={(columnIndex) =>
          previewData.previewTimestampColumnIndexes.includes(columnIndex)
        }
        isMatchedStatusCell={(value, columnIndex) =>
          previewData.previewStatusColumnIndexes.includes(columnIndex) &&
          previewData.matchedStatuses.has(normalizeStatus(value))
        }
        resolveMatchedStatusLabel={resolveMatchedStatusLabel}
        isValidDurationCell={(value, columnIndex) =>
          previewData.previewDurationColumnIndexes.includes(columnIndex) &&
          isValidDurationValue(value)
        }
        isValidTimestampCell={(value, columnIndex) =>
          previewData.previewTimestampColumnIndexes.includes(columnIndex) &&
          isValidTimestampValue(value)
        }
      />
    </>
  );
};
